import styled from "styled-components";

export const GalleryWrap = styled.div `
    img{
        border-radius: 5px;
    }
`;